<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Log in and start playing MATR1X FIRE !"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        Once you've downloaded and installed the game, open MATR1X FIRE and choose to log in with your email, Google,
        Facebook, Apple, VK, or as a guest to start your adventure.
      </div>
      <div class="sub-title">
        Friendly Reminder: To check your game account's assets on the official website, please use the same login
        method.
      </div>
      <div class="sub-title">
        If you encounter any other issues, please contact MATR1X FIRE's official customer support for assistance.
      </div>
      <div class="sub-title">
        Telegram: <a target="_blank" href="https://t.me/Matr1xFireAnn">https://t.me/Matr1xFireAnn</a>
        <i class="el-icon-caret-right"></i>
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>